module.exports = __webpack_public_path__ + "assets/HKNova-Medium.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Medium.eot
// module id = 132
// module chunks = 0